import React from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';

// Define the type for `cellData` prop
interface CellData {
  leading?: string | null;
  textAlign?: string;
  type: string;
  placeholder?: string;
  min?: number;
  name: string;
  id: string;
  value: string | number;
  step?: number;
  precision?: number;
}

// Define the types for the props of EditableField component
interface EditableFieldProps {
  cellData: CellData;
  onItemizedItemEdit: React.ChangeEventHandler<HTMLInputElement>;
}
const EditableField: React.FC<EditableFieldProps> = ({cellData, onItemizedItemEdit}) =>
 {

    return (
      <InputGroup className="my-1 flex-nowrap">
        {
          cellData.leading != null &&
          <InputGroup.Text
            className="bg-light fw-bold border-0 text-secondary px-2">
            <span className="border border-2 border-secondary rounded-circle d-flex align-items-center justify-content-center small" style={{ width: '20px', height: '20px' }}>
              {cellData.leading}
            </span>
          </InputGroup.Text>
        }
        <Form.Control
          className={cellData.textAlign}
          type={cellData.type}
          placeholder={cellData.placeholder}
          min={cellData.min}
          name={cellData.name}
          id={cellData.id}
          value={cellData.value}
          step={cellData.step}
          aria-label={cellData.name}
          onChange={onItemizedItemEdit}
          required
        />
      </InputGroup>
    );
  }

export default EditableField;
